import { render, staticRenderFns } from "./relation.vue?vue&type=template&id=fa1592f2&scoped=true"
import script from "./relation.vue?vue&type=script&lang=ts"
export * from "./relation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1592f2",
  null
  
)

export default component.exports